define(['components/common/MNotification/MNotificationManager'], (MNotificationManager) => ({
    clear () {
        MNotificationManager.closeAllNotifications();
        return this;
    },
    info (options) {
        MNotificationManager.showNotification({
            type: 'warning',
            header: options.title,
            text: options.text
        });
        return this;
    },
    warning (options) {
        MNotificationManager.showNotification({
            type: 'warning',
            header: options.title,
            text: options.text
        });
        return this;
    },
    success (options) {
        MNotificationManager.showNotification({
            type: 'success',
            header: options.title,
            text: options.text
        });
        return this;
    },
    error (options) {
        MNotificationManager.showNotification({
            type: 'error',
            header: options.title,
            text: options.text
        });
        return this;
    }
}));
